import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lib-hover-id',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      class="hover-id"
      [class.hover-id--active]="hasValue"
      [attr.tabindex]="hasValue ? 0 : null"
    >
      <ng-content />
      @if (hasValue) {
        <span class="hover-id__tooltip" role="tooltip">{{ normalizedValue }}</span>
      }
    </span>
  `,
  styles: [`
    :host {
      display: inline-block;
      max-width: 100%;
    }

    .hover-id {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
      max-width: 100%;
      min-width: 0;
      vertical-align: top;
    }

    .hover-id--active {
      cursor: help;
    }

    .hover-id--active:hover,
    .hover-id--active:focus {
      color: #1d4ed8;
    }

    .hover-id__tooltip {
      position: absolute;
      left: 50%;
      bottom: calc(100% + 10px);
      z-index: 40;
      width: max-content;
      min-width: min(220px, calc(100vw - 32px));
      max-width: min(420px, calc(100vw - 32px));
      padding: 8px 10px;
      border: 1px solid rgba(148, 163, 184, 0.28);
      border-radius: 8px;
      background: #111827;
      color: #ffffff;
      box-shadow: 0 14px 34px rgba(15, 23, 42, 0.26);
      font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
      font-size: 11px;
      line-height: 1.35;
      overflow-wrap: anywhere;
      opacity: 0;
      pointer-events: none;
      transform: translate(-50%, 4px);
      transition: opacity 120ms ease, transform 120ms ease;
      white-space: normal;
    }

    .hover-id__tooltip::after {
      content: '';
      position: absolute;
      left: 50%;
      top: calc(100% - 1px);
      width: 9px;
      height: 9px;
      border-right: 1px solid rgba(148, 163, 184, 0.28);
      border-bottom: 1px solid rgba(148, 163, 184, 0.28);
      background: #111827;
      transform: translateX(-50%) rotate(45deg);
    }

    .hover-id--active:hover .hover-id__tooltip,
    .hover-id--active:focus-within .hover-id__tooltip,
    .hover-id--active:focus .hover-id__tooltip {
      opacity: 1;
      transform: translate(-50%, 0);
    }

    @media (max-width: 640px) {
      .hover-id__tooltip {
        left: auto;
        right: 0;
        transform: translateY(4px);
      }

      .hover-id__tooltip::after {
        left: auto;
        right: 18px;
        transform: rotate(45deg);
      }

      .hover-id--active:hover .hover-id__tooltip,
      .hover-id--active:focus-within .hover-id__tooltip,
      .hover-id--active:focus .hover-id__tooltip {
        transform: translateY(0);
      }
    }
  `],
})
export class HoverIdComponent {
  @Input() public value: string | null | undefined = null;

  protected get normalizedValue(): string {
    return this.value?.trim() ?? '';
  }

  protected get hasValue(): boolean {
    return this.normalizedValue.length > 0;
  }
}
